import _isFunction from 'lodash/isFunction';
import Config from '$root/Config';

import InfoBox from '../InfoBox/InfoBox.vue'
import EditOverlayChildMixin from '$mixins/EditOverlayChildMixin';
import { formatDate } from '$utils/Utils';

function parseApiDate(value) {
	if (value instanceof Date) return value;
	if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) {
		const [year, month, day] = value.split('T')[0].split('-').map(Number);
		return new Date(year, month - 1, day);
	}
	const parsed = new Date(value);
	return isNaN(parsed) ? new Date() : parsed;
}

export default {
	props: {
		startDate: {
			type: [String, Date],
			required: false,
		},
		overlayTitle: {
			type: String,
			default: 'Datum aanpassen',
		},
		submitName: {
			type: String,
			default: undefined,
		},
		resetValue: {
			type: Boolean,
			default: true,
		},
		enabledDates: {
			type: Array,
			default: () => [],
		},
		infoBox: {
			type: Object,
			default: () => {},
		},
		minDate: {
			type: String,
			default: ''
		}
	},

	components: {
		InfoBox
	},

	mixins: [EditOverlayChildMixin],

	emits: ['apply', 'close', 'afterhide'],

	mounted() {
		this.showApply();
		this.currentDate = this.startDate || new Date();
	},

	data() {
		return {
			currentDate: null,
			dateKey: 0
		};
	},

	computed: {
		currentValue: {
			get() {
				return formatDate(
					this.currentDate || this.startDate || new Date(),
					Config.apiDateFormat,
				);
			},
			set(value) {
				if (!value) return;
				this.currentDate =
					value instanceof Date ? value : parseApiDate(value);
			},
		},
	},

	methods: {
		_onApplyClick(e) {
			if (e && _isFunction(e.preventDefault)) {
				e.preventDefault();
			}
			this.$emit('apply', this.currentDate || new Date());
			if (this.resetValue) {
				this.currentDate = this.startDate || new Date();
			}
			this.hide();
			this.showApply();
		},
		afterhide() {
			this.$emit('afterhide');
		},
		_onCloseClick() {
			this.$emit('close')
		},
		resetDate() {
			this.currentValue = this.startDate || new Date();
			this.dateKey++;
		},
	},

	watch: {
		startDate(val) {
			if (val) {
				this.currentDate = val
			}
		}
	}
};
